// extracted by mini-css-extract-plugin
module.exports = {"github":"SignInWithGitHub_github__1WlVQ"};